/* Glacier Gin — theme scripts: cart drawer, bundle builder, tier progress, age gate */
(function () {
  'use strict';
  var T = window.GlacierTheme || { tiers: [], routes: {}, moneyFormat: '{{amount}}' };
  var tiers = (T.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = T.moneyFormat || '{{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function delim(n, prec, thou, dec) {
      prec = prec == null ? 2 : prec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thou || ','));
      return dollars + (parts[1] ? (dec || '.') + parts[1] : '');
    }
    var v;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = delim(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      default: v = delim(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  T.formatMoney = formatMoney;

  /* ---------- Tier helpers ---------- */
  function activeTier(qty) {
    var t = null;
    tiers.forEach(function (x) { if (qty >= x.qty) t = x; });
    return t;
  }
  function nextTier(qty) {
    for (var i = 0; i < tiers.length; i++) if (qty < tiers[i].qty) return tiers[i];
    return null;
  }
  function tierHint(qty) {
    var next = nextTier(qty), cur = activeTier(qty);
    if (!tiers.length) return '';
    if (next) {
      var n = next.qty - qty;
      return (cur ? 'You’re saving ' + cur.pct + '%. ' : '') +
        'Add ' + n + ' more bottle' + (n > 1 ? 's' : '') + ' to save ' + next.pct + '%.';
    }
    return 'Top tier unlocked — you’re saving ' + cur.pct + '%.';
  }
  function tierProgress(qty) {
    if (!tiers.length) return 0;
    var max = tiers[tiers.length - 1].qty;
    return Math.min(100, Math.round((qty / max) * 100));
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- Cart API ---------- */
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
        return j;
      });
    });
  }
  function fetchCart() { return api(T.routes.cart); }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function bottleCount(cart) {
    return cart.items.reduce(function (n, i) { return n + (i.product_type && /gift|merch|glass|tonic/i.test(i.product_type) ? 0 : i.quantity); }, 0);
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count);
    });
    if (!drawer) return;
    var items = drawer.querySelector('[data-drawer-items]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    var tierBox = drawer.querySelector('[data-drawer-tier]');
    var bottles = bottleCount(cart);

    if (tierBox) {
      tierBox.hidden = !tiers.length || !cart.item_count;
      tierBox.querySelector('[data-tier-hint]').textContent = tierHint(bottles);
      tierBox.querySelector('[data-tier-bar]').style.width = tierProgress(bottles) + '%';
    }

    if (!cart.item_count) {
      items.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn" href="/collections/all">Shop the gin</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    items.innerHTML = cart.items.map(function (i, idx) {
      var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="' + esc(i.product_title) + '" loading="lazy" width="72" height="72">' : '';
      var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<span class="line__variant">' + esc(i.variant_title) + '</span>' : '';
      var was = i.original_line_price > i.final_line_price ? '<s>' + formatMoney(i.original_line_price) + '</s>' : '';
      return '<div class="line">' +
        '<div class="line__media">' + img + '</div>' +
        '<div><a class="line__title" href="' + i.url + '">' + esc(i.product_title) + '</a>' + variant +
        '<div class="qty" style="margin-top:.5rem"><button type="button" aria-label="Decrease" data-line-change="' + (idx + 1) + '" data-qty="' + (i.quantity - 1) + '">−</button>' +
        '<input type="number" value="' + i.quantity + '" aria-label="Quantity" readonly>' +
        '<button type="button" aria-label="Increase" data-line-change="' + (idx + 1) + '" data-qty="' + (i.quantity + 1) + '">+</button></div></div>' +
        '<div class="line__price">' + was + formatMoney(i.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    renderDuoUpsell(cart);
    var ship = drawer.querySelector('[data-free-ship]');
    if (ship) {
      var goal = +ship.dataset.freeShip, left = goal - cart.total_price;
      ship.hidden = !cart.item_count;
      ship.querySelector('[data-free-ship-text]').textContent = left > 0 ? 'Spend ' + formatMoney(left) + ' more for free delivery.' : 'You have free delivery.';
      ship.querySelector('[data-free-ship-bar]').style.width = Math.min(100, Math.round(cart.total_price / goal * 100)) + '%';
    }

    var saved = cart.total_discount || (cart.original_total_price - cart.total_price);
    foot.querySelector('[data-subtotal]').textContent = formatMoney(cart.total_price);
    var saveRow = foot.querySelector('[data-savings-row]');
    saveRow.hidden = !(saved > 0);
    foot.querySelector('[data-savings]').textContent = '−' + formatMoney(saved);
  }

  /* ---------- Glacier Duo upsell in the cart ---------- */
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* analytics optional */ }
  }
  function renderDuoUpsell(cart) {
    var box = drawer && drawer.querySelector('[data-duo-upsell]');
    var duo = T.duo;
    if (!box) return;
    if (!duo || !cart.item_count) { box.hidden = true; return; }
    var hasDuo = cart.items.some(function (i) { return i.variant_id === duo.variant; });
    var lineIndex = -1, single = null;
    cart.items.forEach(function (i, idx) {
      if (lineIndex < 0 && duo.items.indexOf(i.product_id) > -1) { lineIndex = idx; single = i; }
    });
    if (hasDuo || !single) { box.hidden = true; return; }
    var extra = duo.price - single.final_price;
    box.innerHTML =
      (duo.image ? '<img src="' + duo.image + '" alt="" width="72" height="72" loading="lazy">' : '') +
      '<div class="drawer__upsell-body">' +
        (duo.badge ? '<span class="duo__badge duo__badge--inline">' + esc(duo.badge) + '</span>' : '') +
        '<strong>Why choose one?</strong>' +
        '<span>Swap your ' + esc(single.product_title) + ' for the ' + esc(duo.title) + (extra > 0 ? ' for ' + formatMoney(extra) + ' more' : '') + '.</span>' +
      '</div>' +
      '<button type="button" class="btn btn--sm" data-duo-swap="' + (lineIndex + 1) + '" data-qty="' + (single.quantity - 1) + '">Upgrade</button>';
    box.hidden = false;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-duo-swap]');
    if (!b || !T.duo) return;
    b.classList.add('is-loading');
    api(T.routes.cartChange, { line: +b.dataset.duoSwap, quantity: Math.max(0, +b.dataset.qty) })
      .then(function () { return api(T.routes.cartAdd, { items: [{ id: T.duo.variant, quantity: 1 }] }); })
      .then(fetchCart).then(function (c) { renderCart(c); track('glacier_duo_upsell', { source: 'cart_drawer' }); })
      .catch(function (err) { toast(err.message); });
  });
  document.addEventListener('submit', function (e) {
    if (e.target.closest('form[data-duo-form]')) track('glacier_duo_add', { source: location.pathname });
  }, true);

  function openDrawer() {
    if (!drawer) { window.location.href = T.routes.cartPage; return; }
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    document.body.classList.remove('drawer-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }
  T.openCart = function () { fetchCart().then(renderCart).then(openDrawer); };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart]');
    if (t && drawer) { e.preventDefault(); T.openCart(); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer-overlay')) { closeDrawer(); return; }
    var lc = e.target.closest('[data-line-change]');
    if (lc) {
      api(T.routes.cartChange, { line: +lc.dataset.lineChange, quantity: Math.max(0, +lc.dataset.qty) })
        .then(renderCart).catch(function (err) { toast(err.message); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- AJAX add-to-cart forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    api(T.routes.cartAdd, { items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }] })
      .then(function () { return fetchCart(); })
      .then(function (cart) { renderCart(cart); openDrawer(); })
      .catch(function (err) { toast(err.message); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Quantity steppers (generic) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = +(input.min || 0), max = +(input.max || 99);
    var v = Math.min(max, Math.max(min, (+input.value || 0) + (+b.dataset.qtyStep)));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Bundle builder ---------- */
  document.querySelectorAll('[data-bundle]').forEach(function (root) {
    var rows = root.querySelectorAll('[data-bundle-item]');
    var btn = root.querySelector('[data-bundle-add]');

    function state() {
      var qty = 0, subtotal = 0, items = [];
      rows.forEach(function (row) {
        var sel = row.querySelector('[data-bundle-variant]');
        var opt = sel && sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
        var id = opt ? +(opt.value || opt.dataset.variantId) : 0;
        var price = opt ? +opt.dataset.price : 0;
        var q = +row.querySelector('input[type="number"]').value || 0;
        row.classList.toggle('is-selected', q > 0);
        if (q > 0) {
          qty += q; subtotal += price * q;
          if (id) items.push({ id: id, quantity: q });
        }
      });
      return { qty: qty, subtotal: subtotal, items: items };
    }

    function update() {
      var s = state();
      var cur = activeTier(s.qty);
      var save = cur ? Math.round(s.subtotal * cur.pct / 100) : 0;
      root.querySelectorAll('[data-tier]').forEach(function (el) {
        el.classList.toggle('is-active', !!cur && +el.dataset.tier === cur.qty);
      });
      root.querySelector('[data-bundle-count]').textContent = s.qty;
      root.querySelector('[data-bundle-subtotal]').textContent = formatMoney(s.subtotal);
      root.querySelector('[data-bundle-save]').textContent = '−' + formatMoney(save);
      root.querySelector('[data-bundle-save-row]').hidden = !save;
      root.querySelector('[data-bundle-total]').textContent = formatMoney(s.subtotal - save);
      root.querySelector('[data-tier-hint]').textContent = s.qty ? tierHint(s.qty) : 'Pick your bottles to start saving.';
      root.querySelector('[data-tier-bar]').style.width = tierProgress(s.qty) + '%';
      btn.disabled = !s.qty;
      btn.querySelector('span').textContent = s.qty ? 'Add ' + s.qty + ' bottle' + (s.qty > 1 ? 's' : '') + ' to cart' : 'Choose your bottles';
    }

    root.addEventListener('change', update);
    btn.addEventListener('click', function () {
      var s = state();
      if (!s.items.length) return;
      btn.classList.add('is-loading');
      api(T.routes.cartAdd, { items: s.items })
        .then(fetchCart)
        .then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
    update();
  });

  /* ---------- Product page: variants + gallery ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var atc = root.querySelectorAll('[data-atc]');

    root.addEventListener('change', function (e) {
      if (!e.target.closest('.variant-picker')) return;
      var opts = Array.prototype.map.call(root.querySelectorAll('.variant-picker'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
      atc.forEach(function (b) {
        b.disabled = !v.available;
        var s = b.querySelector('span'); if (s) s.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      if (window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
      if (v.featured_media) {
        var thumb = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
    });

    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (!th) return;
      var main = root.querySelector('[data-main-media] img');
      if (main) { main.src = th.dataset.src; main.srcset = th.dataset.srcset || ''; }
      root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === th); });
    });

    var sticky = document.querySelector('[data-sticky-atc]');
    var form = root.querySelector('.buy-row');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(form);
      sticky.querySelector('button').addEventListener('click', function () {
        root.querySelector('form[data-ajax-cart]').requestSubmit();
      });
    }
  });

  /* ---------- Mobile nav ---------- */
  var nav = document.getElementById('MobileNav');
  document.addEventListener('click', function (e) {
    if (!nav) return;
    if (e.target.closest('[data-menu-open]')) { nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false'); }
    if (e.target.closest('[data-menu-close]')) { nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------- Age gate ---------- */
  var gate = document.getElementById('AgeGate');
  if (gate && T.ageGate && !/designMode/.test(document.documentElement.dataset.mode || '') && !window.Shopify?.designMode) {
    var ok = false;
    try { ok = localStorage.getItem('glacier_age_ok') === '1'; } catch (err) { ok = false; }
    if (!ok) { gate.classList.add('is-visible'); document.body.classList.add('age-locked'); }
    gate.addEventListener('click', function (e) {
      if (e.target.closest('[data-age-yes]')) {
        try { localStorage.setItem('glacier_age_ok', '1'); } catch (err) { /* storage unavailable */ }
        gate.classList.remove('is-visible'); document.body.classList.remove('age-locked');
      }
      if (e.target.closest('[data-age-no]')) {
        gate.querySelector('.age-gate__denied').style.display = 'block';
        gate.querySelector('.age-gate__actions').style.display = 'none';
      }
    });
  }

  /* ---------- Header over hero ---------- */
  var header = document.querySelector('[data-header]');
  if (header && header.classList.contains('site-header--overlay')) {
    var onHead = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
    window.addEventListener('scroll', onHead, { passive: true }); onHead();
  }

  /* ---------- Parallax ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var px = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (px.length && !reduceMotion) {
    var pxQueued = false;
    var runPx = function () {
      pxQueued = false;
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var host = el.parentElement.getBoundingClientRect();
        if (host.bottom < -200 || host.top > vh + 200) return;
        var off = (host.top + host.height / 2 - vh / 2) * parseFloat(el.dataset.parallax);
        el.style.transform = 'translate3d(0,' + (-off).toFixed(1) + 'px,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!pxQueued) { pxQueued = true; requestAnimationFrame(runPx); } }, { passive: true });
    runPx();
  }

  /* ---------- Light shimmer on water ---------- */
  document.querySelectorAll('[data-shimmer]').forEach(function (cv) {
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var full = cv.hasAttribute('data-shimmer-full');
    var w, h, dpr = Math.min(window.devicePixelRatio || 1, 2), streaks = [], running = false, t0 = performance.now();
    function size() {
      var r = cv.getBoundingClientRect(); w = r.width; h = r.height;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      var count = Math.round(w / (full ? 9 : 12));
      streaks = [];
      for (var i = 0; i < count; i++) {
        var y = full ? Math.random() : 0.55 + Math.pow(Math.random(), 1.6) * 0.45;
        streaks.push({ x: Math.random(), y: y, len: 0.01 + Math.random() * 0.05 * (0.4 + y), sp: 0.2 + Math.random() * 0.8, ph: Math.random() * 6.28, a: 0.05 + Math.random() * 0.16 });
      }
    }
    function draw(now) {
      if (!running) return;
      var t = (now - t0) / 1000;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      streaks.forEach(function (s) {
        var tw = 0.5 + 0.5 * Math.sin(t * s.sp * 1.6 + s.ph);
        var x = ((s.x + Math.sin(t * 0.05 * s.sp + s.ph) * 0.02) % 1) * w;
        var y = s.y * h + Math.sin(t * s.sp + s.ph) * 1.5;
        var l = s.len * w * (0.6 + tw * 0.6);
        var g = ctx.createLinearGradient(x - l / 2, 0, x + l / 2, 0);
        g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(0.5, 'rgba(235,250,255,' + (s.a * tw).toFixed(3) + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g; ctx.fillRect(x - l / 2, y, l, 1 + s.y * 1.2);
      });
      requestAnimationFrame(draw);
    }
    size();
    if (reduceMotion) { running = true; draw(t0); running = false; return; }
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(cv);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        if (vis && !running) { running = true; requestAnimationFrame(draw); }
        if (!vis) running = false;
      }).observe(cv);
    } else { running = true; requestAnimationFrame(draw); }
  });

  /* ---------- Cookie settings (Shopify consent banner) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cookie-settings]')) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
        else if (T.routes.cookiePolicy) window.location.href = T.routes.cookiePolicy;
      });
    } else if (T.routes.cookiePolicy) { window.location.href = T.routes.cookiePolicy; }
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Initial cart count sync */
  if (drawer && T.routes.cart) fetchCart().then(renderCart).catch(function () {});
})();
